import { toEnDigits } from '~/utils/faDigits'

const COMPLETE = /^09\d{9}$/

/** Canonical Iranian mobile: `09` + 9 digits, or a shorter prefix while typing. */
export function normalizeIrMobile(raw: string): string {
  let digits = toEnDigits(raw).replace(/\D/g, '')
  if (digits.startsWith('0098')) digits = digits.slice(4)
  else if (digits.startsWith('98')) digits = digits.slice(2)
  if (digits.startsWith('0')) digits = digits.slice(1)
  digits = digits.slice(0, 10)
  return digits ? `0${digits}` : ''
}

/** National digits after +98, grouped `912 345 6789`. */
export function formatIrMobileNational(phone09: string): string {
  const rest = phone09.startsWith('0') ? phone09.slice(1) : phone09.replace(/\D/g, '')
  return [rest.slice(0, 3), rest.slice(3, 6), rest.slice(6, 10)].filter(Boolean).join(' ')
}

/** Local form with the leading zero kept, grouped `0912 345 6789`. */
export function formatIrMobileLocal(phone09: string): string {
  const groups = formatIrMobileNational(phone09)
  return groups ? `0${groups}` : ''
}

export function isCompleteIrMobile(phone09: string): boolean {
  return COMPLETE.test(phone09)
}
